/**
 * iconName -> string = rota/caminnho do icone inserido
 * imgName -> string = rota/caminnho da imagem inserida
 * title -> string = título do card
 * content -> string = conteúdo central do card
 */

import getImage from "../../useFull/getImage";
import "./CardHome.css";

const CardHome = (props) => {
  const { iconName, imgName, title, content } = props;

  return (
    <div className="container-card-home w-box-shadow">
      <div className="container-card">
        <div className="container-card-responsive">
          <div
            style={{
              backgroundImage: `url(${getImage("card-home", iconName)})`,
            }}
            className="bg-card-icon container-card-icon"
          />
          <div className="container-card-content">
            <span
              className="text-title-secondary title-card"
              dangerouslySetInnerHTML={{ __html: title }}
            ></span>
            <span className="content-card">{content}</span>
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${getImage("card-home", imgName)})`,
          }}
          className="img-card"
        />
      </div>
    </div>
  );
};

export default CardHome;
